import React, { FC, useEffect, useState } from 'react'
import { useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { MessageType } from 'src/components/LiveQuestions/LiveQuestions'
import { AdminQuestionCard } from '../../components/LiveQuestions/AdminQuestionCard'
import { AuditoriumQuestion, HallOneDb, HallTwoDb } from '../../firebaseConfig'
import useQuestion from '../../utils/questionHelper'
import { PageStyle } from './styled'

export enum QuestionTabEnum {
  'All' = 'All',
  'Unpresented' = 'Unpresented',
  'Presented' = 'Presented',
  'Archived' = 'Archived',
}

export const AdminLiveQuestionPage: FC<RouteComponentProps> = ({ match }) => {
  const hallNumber = match.params['hallNumber']

  const { messages, messagesLoading, setQuestionStatus } = useQuestion(AuditoriumQuestion)
  const [pinned, setPinned] = useState<MessageType & { key: string }>(null)
  const [currentTab, setCurrentTab] = useState<QuestionTabEnum>(QuestionTabEnum.All)
  const questionsRef = useRef<HTMLSelectElement>(null)

  useEffect(() => {
    const pinnedQuestion = messages.filter((ques) => ques.featured)
    if (pinnedQuestion.length > 0) {
      setPinned(pinnedQuestion[0])
    } else {
      setPinned(null)
    }
  }, [messages])

  useEffect(() => {
    if (questionsRef) {
      questionsRef.current.scrollTop = questionsRef.current.scrollHeight
    }
  }, [messagesLoading])

  const getQuestionsByTab = (): Array<MessageType> => {
    switch (currentTab) {
      case QuestionTabEnum.Archived:
        return messages.filter((question) => question.archived) as Array<MessageType>

      case QuestionTabEnum.Presented:
        return messages.filter((question) => question.show) as Array<MessageType>

      case QuestionTabEnum.Unpresented:
        return messages.filter((question) => !question.archived && !question.show) as Array<MessageType>

      case QuestionTabEnum.All:
        return messages.filter((question) => !question.archived) as Array<MessageType>

      default:
        return messages
    }
  }

  const onTabSwitch = (e) => {
    setCurrentTab(e.target.value)
  }

  const handleArchieved = (mes) => {
    setQuestionStatus(mes.key, 'archived', !mes.archived)
  }

  const handleFeatured = (mes) => {
    if (pinned) {
      setQuestionStatus(pinned.key, 'featured', !pinned.featured)
    }
    setQuestionStatus(mes.key, 'featured', !mes.featured)
  }

  const handleShow = (mes) => {
    setQuestionStatus(mes.key, 'show', !mes.show)
  }

  return (
    <PageStyle>
      <div className="pageContainer">
        <header className="d-flex justify-content-between align-items-center">
          <h5>
            Auditorium Live Question
            {/* <span className="badge rounded-pill badge-warning ml-3">Lecture Hall {hallNumber === '1' ? 'A' : 'B'}</span> */}
          </h5>
          <div>
            {/* <a className="btn btn-sm btn-outline-warning rounded-pill mx-3 my-1" href={`/live-questions/${hallNumber === '1' ? '2' : '1'}`}>
              Switch Hall
            </a> */}
            <select className="form-input" value={currentTab} name="tab" onChange={onTabSwitch}>
              {Object.keys(QuestionTabEnum).map((item, i) => (
                <option key={`tab-${i}`} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </header>
        <section className="questionsContainer" ref={questionsRef}>
          {getQuestionsByTab().map((message, index) => (
            <AdminQuestionCard
              key={message.dbTimestamp}
              message={message}
              handleArchieved={handleArchieved}
              handleFeatured={handleFeatured}
              handleShow={handleShow}
            />
          ))}
        </section>
      </div>
    </PageStyle>
  )
}
